module.exports = __webpack_public_path__ + "static/grassy-2-77f3851181ecb3804c2b731d5dc9b3ea.jpg";